<div class="container">
  <div class="row justify-content-center text-center mt-3">
    <!-- Castometre iOS -->
    @if (castometre.enabled) {
      <figure class="configurator-menu castometre-card">
        <div class="castometre-panel">
          <div class="castometre-main">
            <div class="castometre-content">
              <h2 [innerHTML]="'homepage.castometre.title' | translate"></h2>
              <span class="castometre-divider" aria-hidden="true"></span>
              <p class="castometre-download">
                <span [innerHTML]="'homepage.castometre.download' | translate"></span>
                <img src="assets/img/home/castometre-logo.png" alt="castomètre" />
              </p>
              @if (castometre.appStoreUrl) {
                <a
                  class="app-store-badge"
                  [href]="castometre.appStoreUrl"
                  target="_blank"
                  rel="noopener"
                  (click)="trackCastometreAppStore()"
                  [attr.aria-label]="'homepage.castometre.app_store_aria' | translate">
                  <img src="assets/img/home/appstore1.png" [alt]="'homepage.castometre.app_store_aria' | translate" />
                </a>
              }
            </div>

            <div class="castometre-phone" aria-hidden="true">
              <img class="phone-screen" src="assets/img/home/castometre-screen.png" alt="" />
              <img class="phone-frame" src="assets/img/home/iphone-15-pro-max-frame.png" alt="" />
            </div>

            <div class="castometre-existing">
              <p>
                <fa-icon [icon]="faArrowRight" aria-hidden="true"></fa-icon>
                <span [innerHTML]="'homepage.castometre.existing' | translate"></span>
              </p>
              <button type="button" (click)="goCastometreProjects()">
                {{ 'homepage.castometre.existing_cta' | translate }}
              </button>
            </div>
          </div>

          <p class="castometre-compatibility" [innerHTML]="'homepage.castometre.compatibility' | translate"></p>
        </div>
      </figure>
    }

    <!-- Kitchen -->
    <figure class="configurator-menu" *ngIf="datas.kitchenEnabled">
      <img class="img-fluid" src="assets/img/home/kitchen.png?v=2" alt="Casto 3D" />
      <figcaption>
        <span class="configurator-description">
          <h2 [innerHtml]="'homepage.kitchen.title' | translate"></h2>
          <p [innerHtml]="'homepage.kitchen.text' | translate"></p>
        </span>
        <span class="d-block mt-4 configurator-buttons">
          <ng-casto-btn
            class="blue"
            (click)="startNewProject('kitchen')"
            [label]="'homepage.cta' | translate"></ng-casto-btn>
          <ng-casto-btn
            class="blue mt-2"
            (click)="goProjects('kitchen')"
            [label]="'homepage.link' | translate"></ng-casto-btn>
        </span>
      </figcaption>
    </figure>

    <!-- Storage -->
    <figure class="configurator-menu" *ngIf="datas.storageEnabled">
      <img class="img-fluid" src="assets/img/home/dressing.jpg?v=3" alt="Casto 3D" />
      <figcaption>
        <span class="configurator-description">
          <h2 [innerHtml]="'homepage.storage.title' | translate"></h2>
          <p [innerHtml]="'homepage.storage.text' | translate"></p>
        </span>
        <span class="d-block mt-4 configurator-buttons">
          <ng-casto-btn
            class="blue"
            (click)="startNewProject('storage')"
            [label]="'homepage.cta' | translate"></ng-casto-btn>
          <ng-casto-btn
            class="blue mt-2"
            (click)="goProjects('storage')"
            [label]="'homepage.link' | translate"></ng-casto-btn>
        </span>
      </figcaption>
    </figure>

    <!-- Bathroom -->
    <figure class="configurator-menu" *ngIf="datas.bathroomEnabled">
      <img class="img-fluid" src="assets/img/home/bathroom.jpg?v=3" alt="Casto 3D" />
      <figcaption>
        <span class="configurator-description">
          <h2 [innerHtml]="'homepage.bathroom.title' | translate"></h2>
          <p [innerHtml]="'homepage.bathroom.text' | translate"></p>
        </span>
        <span class="d-block mt-4 configurator-buttons">
          <ng-casto-btn
            class="blue"
            (click)="startNewProject('bathroom')"
            [label]="'homepage.cta' | translate"></ng-casto-btn>
          <ng-casto-btn
            class="blue mt-2"
            (click)="goProjects('bathroom')"
            [label]="'homepage.link' | translate"></ng-casto-btn>
        </span>
      </figcaption>
    </figure>

    <!-- Configurateur 2D -->
    <figure class="configurator-menu" *ngFor="let app of datas.customerAppsEnabled">
      <img
        class="img-fluid"
        [src]="'assets/img/home/' + app + '.jpg'"
        [alt]="'homepage.' + app + '.title' | translate" />
      <figcaption>
        <span class="configurator-description">
          <h2 [innerHtml]="'homepage.' + app + '.title' | translate"></h2>
          <p [innerHtml]="'homepage.' + app + '.text' | translate"></p>
        </span>
        <span class="d-block mt-4 configurator-buttons">
          <ng-casto-btn class="blue" (click)="startNewProject(app)" [label]="'homepage.cta' | translate"></ng-casto-btn>
          <ng-casto-btn
            class="blue mt-2"
            (click)="goProjects(app)"
            [label]="'homepage.link' | translate"></ng-casto-btn>
        </span>
      </figcaption>
    </figure>
  </div>
</div>
